import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// @material-ui/icons
// core components
import MyHeader from 'components/Header/MyHeader.js'
import MyFooter from 'components/Footer/MyFooter.js'
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Parallax from 'components/Parallax/Parallax.js'
// sections for this page
import MyHeaderLinks from 'components/Header/MyHeaderLinks.js'

import IntroSection from './Sections/IntroSection.js'

import styles from 'assets/jss/material-kit-react/views/companyPage.js'

const useStyles = makeStyles(styles)

export default function CompanyPage(props) {
  const classes = useStyles()
  const { ...rest } = props
  return (
    <div>
      <MyHeader color="white" brand="江苏硕佰建筑科技有限公司" fixed rightLinks={<MyHeaderLinks />} {...rest} />
      <Parallax small image={require('assets/img/companyPage/nanjing.jpg')}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>企业概况</h1>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <IntroSection />
      </div>
      <MyFooter />
    </div>
  )
}
